<template>
  <el-main class="container">
    <Nav>
      <div class="left" slot="left">
        <el-button v-show="hasAuthority('addAdmin')" type="primary" @click="event().showDialog('add')">添加管理员</el-button>
      </div>
    </Nav>
    <table-pagination
      ref="table"
      :config="config"
      :datasource="datasource"
      :idRow="true"
      class="table"
      :width='200'
      @change-page="handlerPageChange">
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        width="300"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-link
              v-show="hasAuthority('editAdmin')"
              type='primary'
              :underline="false"
              class="details"
              @click="event().showDialog('set', scope)">
              编辑</el-link>
            <el-link
              v-show="hasAuthority('deleteAdmin')"
              style="margin-left: 5px"
              type='primary'
              :underline="false"
              class="details"
              @click="event().deleteAuthority(scope)">
              删除</el-link>
          </div>
        </template>
      </el-table-column>
    </table-pagination>
    <el-dialog
      width="600px"
      class="dialog"
      :show-close="false"
      :title="title"
      :visible.sync="showDialog">
      <el-form
        label-width="80px">
        <el-form-item label="管理员姓名">
          <el-input
            v-model="editorBody.name"
            placeholder="请输入管理员姓名"
            type="text"/>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input
            v-model="editorBody.mobile"
            placeholder="请输入手机号码"
            type="number"/>
        </el-form-item>
        <el-form-item label="管理员账号">
          <el-input
            v-model="editorBody.account"
            placeholder="请输入管理员账号"
            type="text"/>
        </el-form-item>
        <el-form-item label="管理员密码">
          <el-input
            v-model="editorBody.password"
            placeholder="请输入管理员密码"
            type="password"/>
        </el-form-item>
        <el-form-item label="管理员身份">
          <el-select
            class="select"
            v-model="adminType"
            placeholder="选择管理员身份">
            <el-option
              v-for="(item,index) in admins"
              :key="index"
              :value="item.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-button type="primary" @click="event().add()" v-if="title === '添加管理员'">添加</el-button>
        <el-button type="primary" @click="event().add()" v-if="title === '编辑管理员'">修改</el-button>
        <el-button @click="showDialog=false">取消</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import Nav from '@/components/nav'
import TablePagination from '@/components/table-pagination'
import { getAuthorityList, deleteAuthority, getIdentifyList, addAdmin, setAdmin } from '@/api/authority'
export default {
  data() {
    return {
      body: {
        pageSize: 10,
        pageIndex: 1,
        word: ''
      },
      editorBody: {
        account: '', // 账号
        mobile: '', // 手机号
        name: '', // 姓名
        password: '', // 密码
        roleUuid: '', // 角色uuid
        uuid: '' // uuid(添加时不用传入)
      },
      indentifyBody: {
        pageSize: 999,
        pageIndex: 1,
        word: ''
      },
      config: {
        size: 10,
        fields: [
          {
            prop: 'name',
            label: '管理员姓名'
          },
          {
            prop: 'mobile',
            label: '手机号码'
          },
          {
            prop: 'account',
            label: '账号'
          },
          {
            prop: 'roleName',
            label: '管理员身份'
          }
        ]
      },
      datasource: {
        total: 0,
        data: []
      },
      showDialog: false,
      title: '',
      adminType: '', // 管理员身份
      admins: [] // 管理员身份选择器
    }
  },
  mounted() {
    this.network().getAuthorityList()
    this.network().getIdentifyList()
  },
  methods: {
    event() {
      return {
        deleteAuthority: (scope) => {
          this.$confirm('是否删除管理员？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.network().deleteAuthority(scope.row.uuid)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        },
        showDialog: (type, scope) => {
          if (type === 'set') {
            this.title = '编辑管理员'
            this.editorBody = scope.row
            this.adminType = scope.row.roleName
          } else if (type === 'add') {
            this.title = '添加管理员'
          }
          this.admins = []
          this.network().getIdentifyList()// 请求获取分类
          this.showDialog = true
        },
        add: () => {
          this.admins.forEach((item, index) => {
            if (item.name === this.adminType) {
              this.editorBody.roleUuid = item.uuid
            }
          })
          if (!this.handlerVarifyBody()) return
          if (this.title === '编辑管理员') {
            this.network().setAdmin()
          } else if (this.title === '添加管理员') {
            this.network().addAdmin()
          }
        }
      }
    },
    network() {
      return {
        getAuthorityList: async() => {
          const { data } = await getAuthorityList(this.body)
          this.datasource.total = data.total
          this.datasource.data = data.list
        },
        deleteAuthority: async(uuid) => {
          await deleteAuthority(uuid)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.network().getAuthorityList()
        },
        getIdentifyList: async() => {
          const { data } = await getIdentifyList(this.indentifyBody)
          data.list.forEach((item, index) => {
            const str = {
              name: item.name,
              uuid: item.uuid
            }
            this.admins.push(str)
          })
        },
        addAdmin: async() => {
          await addAdmin(this.editorBody)
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
          this.showDialog = false
          this.network().getAuthorityList()
        },
        setAdmin: async() => {
          await setAdmin(this.editorBody)
          this.$message({
            type: 'success',
            message: '修改成功!'
          })
          this.showDialog = false
          this.network().getAuthorityList()
        }
      }
    },
    handlerVarifyBody() {
      const { editorBody, adminType } = this
      if (!editorBody.name) {
        this.$message({
          message: '请填写管理员名称',
          type: 'warning'
        })
        return false
      }
      if (!editorBody.mobile) {
        this.$message({
          message: '请填写手机号码',
          type: 'warning'
        })
        return false
      }
      if (!(/^1[3456789]\d{9}$/.test(editorBody.mobile))) {
        this.$message({
          message: '请填写正确手机号',
          type: 'warning'
        })
        return false
      }
      if (!editorBody.account) {
        this.$message({
          message: '请填写管理员账号',
          type: 'warning'
        })
        return false
      }
      if (!editorBody.password) {
        this.$message({
          message: '请填写管理员密码',
          type: 'warning'
        })
        return false
      }
      if (!adminType) {
        this.$message({
          message: '请选择管理员身份',
          type: 'warning'
        })
        return false
      }
      return true
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getAuthorityList()
    }
  },
  components: {
    Nav,
    TablePagination
  }
}
</script>

<style scoped lang="scss">
.container{
  Nav{
    margin-bottom: 15px;
  }
  .el-dialog__wrapper{
    /deep/ .el-dialog{
      padding: 15px 15px;
      border-radius: 15px
    }
    /deep/ .el-dialog__title{
      font-weight: bold;
    }
    /deep/ .el-form-item{
      width: 85%;
      display: flex;
      /deep/ .el-form-item__label{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex: 1;
      }
      /deep/ .el-form-item__content{
        margin-left: 20px !important;
        flex: 4;
        input{
          padding: 25px 10px;
        }
      }
    }
    .btn-box{
      display: flex;
      justify-content: center;
    }

    .select{
      width: 100%;
    }
  }
}

/deep/ .table{
  /deep/ .el-table__body .el-table__row{
    height: 150px;
  }
}
</style>
